import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  private apiUrl = 'https://exam.alarkkan.app/api/api/call'; 
  userId: number = 0;
  private traningAppUrl = 'https://alarkkan.app/api/';

  constructor(private http: HttpClient) { }

  getUserPermissions(userEmail:string): Observable<any> {
    const body = {
      procedureName: 'GetUserPermissions',
      params: {
         Email: userEmail
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getAllUserPermissions(): Observable<any> {
    const body = {
      procedureName: 'GetAllUserPermissions',
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  setUserId(id: number): void {
    this.userId = id;
  }

  getUserId(): number {
    return this.userId;
  }

  updateUserPermissions(userID: number, permissions: string, branchId: number, branchName: string): Observable<any> {
    const body = {
      procedureName: 'UpdateUserPermissions',
      params: {
        UserID: userID,
        Permissions: permissions,
        UpdatedBy: this.userId,
        branchId: branchId,
        branchName: branchName
      },
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' }});
  }
  
  addNewUser(username: string, email: string, branchId: number, branchName: string): Observable<any> {
      const body = {
      procedureName: 'sp_InsertUser',
      params: {
        Username: username,
        Email: email,
        CreatedBy: this.userId,
        branchId: branchId,
        branchName: branchName
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getAllBranches(): Observable<any> {
    return this.http.get<any>(this.traningAppUrl + 'branches/getbranches');
  }
}
